module.exports = __webpack_public_path__ + "static/img/walkway-t-crossing_256.417a391.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/walkway-t-crossing_256.png
// module id = tSUD
// module chunks = 0